import { render } from "./DashboardSummaryCard.vue?vue&type=template&id=88442c4e"
import script from "./DashboardSummaryCard.vue?vue&type=script&lang=js"
export * from "./DashboardSummaryCard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__